'use strict';

const baseURL = window.location.hostname === 'localhost'
    ? 'http://localhost:3000/api/songs'
    : `${process.env.API_URL}/songs`;

export const songs = (() => {
    const getSongs = async () => {
        try {
            const response = await fetch(`${baseURL}`);
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            const result = await response.json();
            return result;
        } catch (error) {
            console.error('Error fetching songs:', error);
            return [];
        }
    };

    const addSong = async (song) => {
        try {
            const response = await fetch(`${baseURL}/addsong`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(song),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }

            const result = await response.json();
            console.log('Song added:', result);
            return result;
        } catch (error) {
            console.error('Error adding song:', error);
            return null;
        }
    };

    const editSong = async (updatedSong) => {
        try {
            const response = await fetch(`${baseURL}/updatesong/${updatedSong.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedSong),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }

            const result = await response.json();
            console.log('Song updated:', result);
            return result;
        } catch (error) {
            console.error('Error updating song:', error);
            return null;
        }
    };

    const removeSong = async (song_id) => {
        try {
            const response = await fetch(`${baseURL}/removesong/${song_id}`, {
                method: 'DELETE',
            });

            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }

            const result = await response.json();
            console.log('Song removed:', result);
            return result;
        } catch (error) {
            console.error('Error removing song:', error);
            return null;
        }
    };

    return {
        getSongs,
        addSong,
        editSong,
        removeSong,
    };
})();
